import { useTranslation } from "react-i18next";
import type { TrackerStrategyDto } from "../../api/hooks/usePortfolioTracker";
import { displayTicker } from "../trading-strategies/tickers";

/** What the strategy trades through: "TQQQ and SQQQ", or the one fund. */
export function useTradesThrough() {
  const { t } = useTranslation("portfolioTracker");
  return (strategy: TrackerStrategyDto) => {
    const bull = displayTicker(strategy.bullSymbol) ?? displayTicker(strategy.chartedSymbol) ?? "";
    const bear = displayTicker(strategy.bearSymbol);
    return bear ? t("ident.through", { bull, bear }) : bull;
  };
}
